// =============================================================================
// ============= Poroduct Details Page dynamic content templates ===============
// =============================================================================

import { monthString, yearString } from "@/app/utilities/constants";

// Dynamic metadata templates for model pages
export const carMetaData = {
    meta_title: `{Brand} {CarName} Price - {Mileage_Range}, Images, Colours & Reviews | Car Junction`,
    meta_description: "{Brand} {CarName} Price in India starts at {StartingPriceNoSymbol}. Check out {Brand} {CarName} on road price, {mileage_range}, colours, images, specifications, features, reviews and new {CarName} variants.",
    meta_description1: "{Brand} {CarName} Price in India starts at {StartingPriceNoSymbol}. Check out {Brand} {CarName} on road price, {mileage_range}, colours, images, specifications, features, reviews and new {CarName} variants.",
    meta_description2: "{Brand} {CarName} price in India is coming soon.. It is available in {VariantCount} variants. Check {Brand} {CarName} on road price, mileage, images, colours, features & reviews.",
    meta_keywords: "{Brand} {CarName}, {Brand} {CarName} price, {Brand} {CarName} on road price, {Brand} {CarName} mileage, {Brand} {CarName} images, {Brand} {CarName} colours, {Brand} {CarName} variants, {Brand} {CarName} features, {Brand} {CarName} car, {Brand} {CarName} price in india, {Brand} {CarName} top model, {Brand} {CarName} base model"
};

export const carMetaDataUpcoming = {
    meta_title: "{Brand} {Model} Expected Price {StartingPrice}, Launch Date, Images & Specs",
    // conditional
    meta_title_1: "{Brand} {CarName} – Expected Price, Launch Date, Images & Specs",
    meta_description: "{Brand} {CarName} expected price in India starts from Rs. {StartingPriceNoSymbol}, with launch scheduled for {LaunchDate}. Check {CarName} images, colours, specifications and latest updates on Car Junction.",
    meta_description_noPrice: "{Brand} {CarName} is set to launch on {LaunchDate}, with its expected price yet to be announced. Check Bigster images, colours, specifications and latest updates on Car Junction",
    meta_description_noLaunchDate: "{Brand} {CarName} expected price in India starts from Rs. {StartingPriceNoSymbol}, with the launch date yet to be revealed. Check Bigster images, colours, specifications and latest updates on Car Junction",
    meta_description_noPrice_noLaunchDate: "{Brand} {CarName} is expected to launch in India soon, though its price and launch date have not been announced yet. Check Bigster images, colours, specifications and latest updates on Car Junction",
}

// Dynamic FAQ templates for model pages
export const modeldynmicFaqs = {
    nonEV: [
        {
            id: 'i1',
            question: 'What is the price of the {CarName}?',
            answer: '{CarName} price ranges starting from {PriceRange}.',
            fallback: 'Price details will be available soon.'
        },
        {
            id: 'i2',
            question: 'What is the mileage of the {CarName}?',
            answer: '{CarName} delivers a mileage of {Mileage}.',
            fallback: 'This car offers decent mileage for everyday use.'
        },
        {
            id: 'i3',
            question: 'What engine does the {CarName} use?',
            answer: '{CarName} comes with a {EngineType} engine.',
            fallback: 'It is powered by a strong engine for balanced performance.'
        },
        {
            id: 'i4',
            question: 'What is the fuel tank capacity of the {CarName}?',
            answer: 'The {CarName} can carry a {FuelTank} fuel tank for long and steady travel.',
            fallback: 'The FuelTank capacity is expected to be decent for the {CarName} model.'
        },
        {
            id: 'i5',
            question: 'What is the seating capacity of the {CarName}?',
            answer: 'The {CarName} offers seating for {SeatingCapacity} passengers.',
            fallback: '{CarName} is expected to come with an optimal seating layout.'
        },
        {
            id: 'i6',
            question: 'What is the boot space of the {CarName}?',
            answer: '{CarName} provides {BootSpace} of boot space.',
            fallback: 'It also provides enough boot space for luggage and essentials.'
        }
    ],
    EV: [
        {
            id: 'e1',
            question: 'What is the price of the {CarName}?',
            answer: '{CarName} price ranges {StartingPrice} - {TopPrice}.',
            fallback: 'Price details will be available soon.'
        },
        {
            id: 'e2',
            question: 'What is the driving range of the {CarName}?',
            answer: '{CarName} delivers a certified driving range of {Range}.',
            fallback: 'It offers a practical driving range for daily use.'
        },
        {
            id: 'e3',
            question: 'What motor does the {CarName} use?',
            answer: '{CarName} comes with a {MotorType} motor.',
            fallback: 'It is expected to come with a capable electric motor.'
        },
        {
            id: 'e4',
            question: 'What is the battery capacity of the {CarName}?',
            answer: 'This model carries a {BatteryCapacity} kWh battery pack.',
            fallback: 'Battery details will be updated soon.'
        },
        {
            id: 'e5',
            question: 'How long does the {CarName} take to charge?',
            answer: 'It supports {ChargingTime} (AC/DC) charging.',
            fallback: 'Charging time will be updated soon.'
        },
        {
            id: 'e6',
            question: 'What is the boot space of the {CarName}?',
            answer: '{CarName} provides {BootSpace} of boot space.',
            fallback: '{CarName} is expected to offer sufficient luggage room.'
        }
    ]
};

// Dynamic top content templates for model pages
export const modelDynamicTopContent = {
    nonEV: {
        priceRange: {
            text: "{CarName} comes in a price range of {PriceRange} in India.",
            fallback: "{CarName} price details will be available soon."
        },
        mileage: {
            text: "This car offers a mileage of {Mileage} for everyday use.",
            fallback: "This car offers decent mileage for everyday use."
        },

        engine: {
            text: "It is powered by a {EngineType} {EngineSize} engine that delivers {MaxPower}.",
            fallback: "It is powered by a strong engine for balanced performance."
        },
        transmissionWheelbase: {
            text: "Also, this model features a {Transmission} transmission, a wheelbase of {Wheelbase}.",
            fallback: ""
        },

        fuelTank: {
            text: "{CarName} offers a fuel tank capacity of {FuelTank}.",
            fallback: "{CarName} supports sufficient fuel capacity for routine travel."
        },

        bootSpace: {
            text: "It also provides a boot space of {BootSpace}, giving enough room for luggage and essentials.",
            fallback: "It also provides enough boot space for luggage and essentials."
        }
    },
    EV: {
        priceRange: {
            text: "{CarName} comes in a price range of {PriceRange} in India.",
            fallback: "{CarName} price details will be available soon."
        },
        mileage: {
            text: "This electric car offers a certified range of {Mileage} km on a full charge.",
            fallback: "This electric car offers decent range for daily use and weekend trips."
        },
        motorBatteryPower: {
            text: "It is powered by a {MotorType} motor paired with a {BatteryCapacity} kWh battery that delivers {MaxPower}.",
            fallback: "",
        },
        charging: {
            text: "{CarName} takes around {ChargingTime} to charge fully.",
            fallback: "{CarName} can be charged easily at home or at charging stations for convenient driving experience."
        },
        bootSpace: {
            text: "It also provides a boot space of {BootSpace}, giving enough room for luggage and essentials.",
            fallback: "It offers sufficient boot space for luggage and essentials."
        }

    }
};


// ===============================================================================
// ============= Price LOcation specific dynamic content templates ===============
// ===============================================================================

// Dynamic FAQ templates for model pages
export const carLocationMetaData = {
    meta_title: `{Brand} {CarName} On Road Price in {CityName} - ${monthString} {Year} Offers`,
    // meta_description: `{Brand} {CarName} Price in {CityName} starts from {StartingPriceNoSymbol} (Ex-showroom). Check ${yearString} {Brand} {CarName} on road price in {CityName} (Ex-Showroom + RTO + Insurance) with latest ${monthString} offers.`,
    meta_description: `{CarName} Car Price in {CityName} starts from {StartingPriceNoSymbol} (Ex-showroom). Check {Year} {Brand} {CarName} on road price in {CityName} (Ex-Showroom + RTO + Insurance) with latest ${monthString} offers`,
    meta_keywords: "{Brand} {CarName} price in {CityName}, {Brand} {CarName} on road price in {CityName}, {Brand} {CarName} ex-showroom price in {CityName}, {Brand} {CarName} base model price in {CityName}, {Brand} {CarName} top model price in {CityName}",
    meta_title_upcoming: "{Brand} {CarName} Expected Price in {CityName} | Car Junction",
    meta_description_upcoming: "{Brand} {CarName} price in {CityName} is expected to start from {StartingPrice}. Check {Brand} {CarName} expected on-road price in {CityName} with latest updates & launch details.",
    meta_description_upcoming_nonPrice: "{Brand} {CarName} price in {CityName} has not been disclosed yet. Check {Brand} {CarName} expected on-road price in {CityName} with latest updates & launch details.",
};

// Dynamic FAQ templates for model pages with location context (like price-in-city pages)
export const sharedCityPriceTopDescriptionContent = {
    singleVariant: {
        text: "{BrandName} {CarName} on-road price in {CityName} is {OnRoadPrice_FORMATTED} with {FuelType} fuel option. The on-road price includes registration, road tax, and insurance charges applicable in {CityName}. Ex-showroom price is {BaseVariantPrice} for {BaseVariantName}. Get the best deal on the new {BrandName} {CarName} today.",
        fallback: "The price of {BrandName} {CarName} in {CityName} is not revealed yet."
    },
    multiVariant: {
        text: "{BrandName} {CarName} on-road price in {CityName} starts at {OnRoadPrice_FORMATTED} and goes up to {TopVariantOnRoadPrice} across {VariantCount} variants with {FuelOptions} fuel options. The on-road price includes registration, road tax, and insurance charges applicable in {CityName}. Ex-showroom price ranges from {BaseVariantPrice} for {BaseVariantName} to {TopVariantPrice} for {TopVariantName}. Get the best deal on the new {BrandName} {CarName} today.",
        fallback: "The price of {BrandName} {CarName} in {CityName} is not revealed yet."
    }
};

export const modelLocationTopContent = {
    nonEV: {
        priceIntro: {
            text: "{BrandName} {CarName} price in {CityName} starts at {StartingPrice}.",
            fallback: "The price of {BrandName} {CarName} in {CityName} is not revealed yet."
        },
        topVariant: {
            text: "The top model of {CarName}, {TopVariantName} is priced at {TopVariantPrice}."
        },
        automaticPricing: {
            textSingle: "The {CarName} automatic model price starts from {StartingPriceAutomatic}.",
            textRange: "The {CarName} automatic model price starts from {StartingPriceAutomatic} and goes up to {MaxPriceAutomatic}."
        },
        alternateFuel: {
            textCng: "The {BrandName} {CarName} CNG model price starts from {StartingPriceCng}.",
            textDiesel: "The {BrandName} {CarName} Diesel model price starts from {StartingPriceDiesel}."
        },
        closing: {
            text: "Get the best deal on new {BrandName} {CarName} today."
        }
    },
    EV: {
        priceIntro: {
            text: "{BrandName} {CarName} price in {CityName} starts at {StartingPrice}.",
            fallback: "The price of {BrandName} {CarName} in {CityName} is not revealed yet."
        },
        topVariant: {
            text: "The top model of {BrandName} {CarName}, {TopVariantName} is priced at {TopVariantPrice}."
        }
    },
    upcoming: {
        priceIntro: {
            text: "The {BrandName} {CarName} price in {CityName} is likely expected to start from {StartingPrice}.",
            fallback: "The {BrandName} {CarName} expected price in {CityName} has not been disclosed yet."
        },
        launchDate: {
            text: " This upcoming model is expected to launch on {LaunchDate}. You can visit your nearest showroom in {CityName} after the launch for the latest updates and best offers.",
            fallback: "The official launch date of this model has not been announced yet. However, you can stay updated with our news section for the reveal of {BrandName} {CarName} launch and feature updates."
        }
    }

};

export const modelLocationTopDescriptionContent = {
    nonEV: sharedCityPriceTopDescriptionContent,
    EV: sharedCityPriceTopDescriptionContent,
    upcoming: modelLocationTopContent.upcoming,
};

// Dynamic FAQ templates for model pages with location context (like price-in-city pages)
export const modelLocationDynamicFaqs = {
    nonEV: [
        {
            id: 'i1',
            question: 'What is the price range of {BrandName} {CarName} in {CityName}?',
            answer: 'The {BrandName} {CarName} comes at a price range between {StartingPrice} and {TopPrice}.',
            fallback: 'The price of {CarName} is not revealed in {CityName}, stay tuned for more information.'
        },
        {
            id: 'i2',
            question: 'What is the starting price of {BrandName} {CarName} in {CityName}?',
            answer: 'The {BrandName} {CarName} base variant, {BaseVariantName} starts from {BaseVariantPrice}.',
            fallback: 'The price of {BrandName} {CarName} will be available soon, stay tuned with Car Junction for more details.'
        },
        {
            id: 'i3',
            question: 'What is the price of top variant of {BrandName} {CarName} in {CityName}?',
            answer: 'The {BrandName} {CarName} top variant, {TopVariantName} is priced at {TopVariantPrice}.',
            fallback: ''
        },
        {
            id: 'i4',
            question: 'Are EMI options available for {BrandName} {CarName} in {CityName}?',
            answer: 'Yes! EMI plans for {BrandName} {CarName} in {CityName} start from {EmiPrice}, which makes it easier to own your dream vehicle.',
            fallback: 'Yes! EMI plans for {BrandName} {CarName} are available in {CityName}, which you can check by visiting the showroom.'
        },
    ],
    EV: [
        {
            id: 'e1',
            question: 'What is the price range of {BrandName} {CarName} in {CityName}?',
            answer: 'The {CarName} comes at a price range between {StartingPrice} and {TopPrice}.',
            fallback: 'The price of {CarName} is not revealed in {CityName}, stay tuned for more information.'
        },
        {
            id: 'e2',
            question: 'What is the starting price of {BrandName} {CarName} in {CityName}?',
            answer: 'The price of {BaseVariantName} starts from {BaseVariantPrice}.',
            fallback: 'The price of {CarName} will be available soon, stay tuned with Car Junction for more details.'
        },
        // {
        //     id: 'e3',
        //     question: 'What motor does the {CarName} use?',
        //     answer: '{CarName} comes with a {MotorType} motor.',
        //     fallback: 'It is expected to come with a capable electric motor.'
        // },
        {
            id: 'e4',
            question: 'What is the price of top variant of {CarName} in {CityName}?',
            answer: 'The {TopVariantName} is priced at {TopVariantPrice}.',
            fallback: ''
        },
        {
            id: 'e5',
            question: 'Are EMI options available for {BrandName} {CarName} in {CityName}?',
            answer: 'Yes! EMI plans for {BrandName} {CarName} in {CityName} start from {EmiPrice}, which makes it easier to own your dream vehicle.',
            fallback: 'Yes! EMI plans for {BrandName} {CarName} are available in {CityName}, which you can check by visiting the showroom.'
        },
    ],
    upcoming: [
        {
            id: 'u1',
            question: 'What is the on-road price of the upcoming {Brand} {Model} in {City}?',
            answer: 'The on-road price of the upcoming {Brand} {Model} in {City} is expected to be {OnRoadPrice}.',
            fallback: 'The on-road price of the upcoming {Brand} {Model} in {City} has not been disclosed yet.'
        },
        {
            id: 'u2',
            question: 'What will be the RTO charges for the upcoming {Brand} {Model} in {City}?',
            answer: 'The RTO charges for the upcoming {Brand} {Model} in {City} are expected to be {RtoPrice}.',
            fallback: 'The RTO charges for the upcoming {Brand} {Model} in {City} have not been disclosed yet.'
        },
        {
            id: 'u3',
            question: 'What will be the insurance charges of the upcoming {Brand} {Model} in {City}?',
            answer: 'The insurance charges for the upcoming {Brand} {Model} in {City} are expected to be {InsuranceCharges}.',
            fallback: 'The insurance charges for the upcoming {Brand} {Model} in {City} have not been disclosed yet.'
        },
        {
            id: 'u4',
            question: 'What is the expected ex-showroom price of the upcoming {Brand} {Model} in {City}?',
            answer: 'The expected ex-showroom price of the upcoming {Brand} {Model} in {City} is likely to start from {StartingPrice}.',
            fallback: 'The expected ex-showroom price of the upcoming {Brand} {Model} in {City} has not been disclosed yet.'
        }
    ]
};
